import Latex from "react-latex";
import MathpixRenderer from "../../pages/admin/renderer/mathpix";


interface DataRendererProps {
    text: string;
    type: 'latex' | 'mathpix';

    options?: {
        htmlTags?: boolean;
        // Add other options as needed
    };
}

export default function DataRenderer(props: DataRendererProps) {

    const { text, type, options } = props;

    if (type === 'latex') {
        return <Latex>{text}</Latex>
    } else if (type === 'mathpix') {
        return <MathpixRenderer text={text} options={options} />
    }else{
        return <Latex>{text}</Latex>
    }

}